const FileViewer = ({ publication_type, file, name, className = "" }) => {
  const mediaClass = ["w-full rounded-[10px]", className].filter(Boolean).join(" ");

  return (
    <div className="w-full">
      {publication_type === "image" && (
        <img src={file} alt={name || "Post"} className={mediaClass} />
      )}
      {publication_type === "pdf" && (
        <iframe
          src={`${file}#toolbar=0`}
          title={name}
          className={`${mediaClass} h-[200px]`}
        />
      )}
      {(publication_type === "doc" || publication_type === "docx") && (
        <iframe
          src={`https://docs.google.com/gview?url=${encodeURIComponent(
            file
          )}&embedded=true`}
          title={name}
          className={`${mediaClass} h-[200px]`}
        />
      )}
      {publication_type === "video" && (
        <video src={file} controls className={mediaClass} />
      )}
      {publication_type === "audio" && (
        <div className="w-full rounded-[10px] flex items-center justify-center bg-gray-100 py-4">
          <audio src={file} controls className="w-full px-4" />
        </div>
      )}
    </div>
  );
};

export default FileViewer;
